import styled from '@emotion/styled';
import { AppUI, ExerciseUI } from '@seedlang/state';
import Breadcrumbs from 'components/breadcrumbs';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { min, startCase } from 'lodash';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import { isBlank, isPresent } from '@seedlang/utils';

const BackButton = styled.span`
  font-weight: bold;
  font-size: 20px;
  color: #222;
  cursor: pointer;
  display: flex;
  height: 100%;
  align-items: center;
  .fa {
    margin-right: 5px;
  }
`;

const Wrapper = styled.div`
  height: 20px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

@observer
class WorksheetBackButton extends React.Component {

  constructor(props) {
    super(props);
    if (isBlank(ExerciseUI.worksheetNamespace) && isPresent(ExerciseUI.routeStore?.routeName)) {
      ExerciseUI.worksheetNamespace = ExerciseUI.routeStore?.routeName?.split('.')[0];
    }
    if (isBlank(ExerciseUI.worksheetId) && isPresent(this.props.worksheetId)) {
      ExerciseUI.worksheetId = this.props.worksheetId;
    }
  }

  @computed get homeRouteName() {
    const routeFirstPart = ExerciseUI.routeStore?.routeName?.split('.')[0];
    if (routeFirstPart === 'exercises') {
      return 'videos.index';
    }
    return `${ExerciseUI.worksheetNamespace}.index`;
  }
  goBackToPosts = () => {
    ExerciseUI.routeStore.routeToNamed(this.homeRouteName);
  }

  @computed get homeName() {
    const routeFirstPart = ExerciseUI.routeStore?.routeName?.split('.')[0];
    if (routeFirstPart === 'exercises') {
      return 'Exercises';
    }
    if (['learn', 'videos', 'podcast'].includes(ExerciseUI.worksheetNamespace)) {
      return startCase(ExerciseUI.worksheetNamespace);
    }
    return startCase(AppUI.user?.site?.navigationItems?.find(item => item.routeName?.startsWith(ExerciseUI.worksheetNamespace))?.name || 'Posts');
  }

  @computed get breadCrumbs() {
    const worksheetRouteId = ExerciseUI.worksheet?.routeId || ExerciseUI.worksheetId;
    const breadCrumbs = [
      {name: this.homeName, routeToName: this.homeRouteName},
    ];
    if (AppUI.layout.isMobile && isPresent(ExerciseUI.worksheet)) {
      if (ExerciseUI.routeStore?.routeName?.endsWith('info.show')) {
        breadCrumbs.push({name: ExerciseUI.worksheet?.nameWithPublished});
      } else {
        breadCrumbs.push({name: ExerciseUI.worksheet?.nameWithPublished, routeToName: `${ExerciseUI.worksheetNamespace}.info.show`, routeToParams: {groupId: ExerciseUI.groupId, worksheetId: worksheetRouteId}});
      }
    }

    if (ExerciseUI.routeStore?.routeName?.endsWith('vocab.word')) {
      breadCrumbs.push({
        name: (AppUI.layout.isMobile || isBlank(ExerciseUI.worksheet)) ? 'Vocab' : ExerciseUI.worksheet?.nameWithPublished,
        routeToName: `${ExerciseUI.worksheetNamespace}.vocab.show`,
        routeToParams: { groupId: ExerciseUI.groupId, worksheetId: worksheetRouteId },
      });
    }

    return breadCrumbs;
  }

  @computed get lastBreadcrumb() {
    return this.breadCrumbs[this.breadCrumbs.length - 1];
  }

  render() {
    if (isBlank(this.breadCrumbs)) {
      return null;
    }
    if (this.props.showAsBreadcrumbs) {
      return (
        <Breadcrumbs
          breadcrumbs={this.breadCrumbs}
          height={null}
          margin={this.props.margin || '0 0 10px 0'}
        />
      );
    }

    return (
      <Wrapper>
        <BackButton
          background={AppUI.site.accentColor}
          top={ExerciseUI.siteIsSeedlang ? min([AppUI.layout.viewportHeight - 100, this.worksheetBottom - 55]) : min([AppUI.layout.viewportHeight - 100, this.worksheetBottom - 61])}
          onClick={() => ExerciseUI.routeStore.routeToNamed(this.lastBreadcrumb.routeToName, this.lastBreadcrumb.routeToParams)}
          margin={this.props.margin || '0 0 0 -40px'}
        >
          <i className='fa fa-angle-left'/>
          <span style={{fontSize: '14px', color: '#222'}}>{this.lastBreadcrumb.name}</span>
        </BackButton>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(WorksheetBackButton);
